import { TiersNeedingCard, tiersNeedingCard } from '../types';

export const isTierNeedingCard = (value: string): value is TiersNeedingCard => {
  const tiersNeedingCardSet = new Set(tiersNeedingCard) as Set<string>;
  return tiersNeedingCardSet.has(value);
};
